module.exports = __webpack_public_path__ + "img/model-icon.e2371fff.png";